var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hazardous-declaration" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "check-list" },
        _vm._l(_vm.items, function(item) {
          return _c(
            "label",
            {
              key: item.key,
              staticClass: "check-item",
              class: {
                checked: _vm.checkedSet[item.key],
                none: item.key === "none",
                priority: item.key === "misc_dangerous"
              }
            },
            [
              _c("input", {
                staticClass: "check-input",
                attrs: { type: "checkbox" },
                domProps: { checked: !!_vm.checkedSet[item.key] },
                on: {
                  change: function($event) {
                    return _vm.toggle(item.key)
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "check-box" }, [
                _vm.checkedSet[item.key]
                  ? _c(
                      "svg",
                      {
                        staticClass: "check-icon",
                        attrs: { viewBox: "0 0 16 16" }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M3.5 8.5l3 3 6-7",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "check-text" },
                [
                  item.key === "misc_dangerous"
                    ? [
                        _c("strong", [_vm._v(_vm._s(item.label))]),
                        _vm._v(" "),
                        item.classLabel
                          ? _c(
                              "span",
                              { staticClass: "check-class inline-class" },
                              [_vm._v(_vm._s(item.classLabel))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "misc-separator" }, [
                          _vm._v(" — ")
                        ]),
                        _vm._v(" "),
                        _vm._l(item.examples, function(example, idx) {
                          return [
                            _c(
                              "strong",
                              {
                                key: example,
                                staticClass: "check-example-emphasis"
                              },
                              [_vm._v(_vm._s(example))]
                            ),
                            idx < item.examples.length - 1
                              ? _c("span", [_vm._v(", ")])
                              : _vm._e()
                          ]
                        })
                      ]
                    : item.key === "none"
                    ? [_c("strong", [_vm._v(_vm._s(item.label))])]
                    : [
                        _c("strong", [_vm._v(_vm._s(item.label))]),
                        _vm._v(" "),
                        item.classLabel
                          ? _c("span", { staticClass: "check-class" }, [
                              _vm._v(_vm._s(item.classLabel))
                            ])
                          : _vm._e()
                      ]
                ],
                2
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "warn-fade" } }, [
        _vm.hasDangerousChecked
          ? _c("div", { staticClass: "warning-banner" }, [
              _c("span", { staticClass: "warning-icon" }, [_vm._v("⚠")]),
              _vm._v(
                "\n      Items containing prohibited / dangerous goods cannot be stored. Please remove these items from your luggage before proceeding.\n    "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "warn-fade" } }, [
        _vm.showSelectionHint
          ? _c("div", { staticClass: "hint-banner" }, [
              _vm._v("\n      Please select "),
              _c("strong", [_vm._v("None of above")]),
              _vm._v(
                " if your luggage does not contain any listed items.\n    "
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "intro-text" }, [
      _vm._v(
        "\n    I declare that to the best of my knowledge, my luggage does "
      ),
      _c("strong", [_vm._v("NOT")]),
      _vm._v(
        " contain\n    any of the following prohibited or dangerous items:\n  "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ece412f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ece412f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HazardousDeclaration.vue
// module id = 429
// module chunks = 0